<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <base-crud
          :ref="'fluxosCrud'"
          crudName="Fluxos"
          newText="Novo Fluxo"
          :table="table"
          :columns="columns"
          :options="options"
          :endPoint="endPoint"
          :enableAdd="true"
          :enableEdit="true"
          :enableDelete="true"
          :enableView="false"
          :enableReset="false"
          :extra="extraButtons"
          :dataForm="dataForm"
          @editor="abrirEditor"
        >
          <div slot="padrao" slot-scope="props">
            <span v-if="props.row.padrao" class="badge badge-info">Padrão</span>
          </div>
          <div slot="status" slot-scope="props">
            <span v-if="props.row.status == 1" class="badge badge-success">Ativo</span>
            <span v-else class="badge badge-secondary">Inativo</span>
          </div>
        </base-crud>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../../layouts/Base/BaseCrud";

export default {
  data: function () {
    return {
      table: "fluxosTable",
      columns: ["id", "nome", "padrao", "status", "actions"],
      extraButtons: [
        {
          id: 1,
          name: "editor",
          title: "Editor visual",
          class: "btn btn-crud edit margin-crud",
          icon: "fas fa-project-diagram",
          label: "",
        },
      ],
      options: {
        filterByColumn: true,
        debounce: 1000,
        filterable: [],
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          id: "ID",
          nome: "Nome",
          padrao: "Padrão",
          status: "Status",
          actions: "Ações",
        },
        texts: {
          filterBy: "Filtrar",
          defaultOption: "Selecione",
        },
        listColumns: {},
        templates: {},
        requestFunction: function (data) {
          let requestData = {};

          let query = this.$parent.$parent.$parent.query(data.query);
          requestData.params = data;
          requestData.params.query = "";

          return axios.get(this.url + "?" + query, requestData).catch(
            function (e) {
              this.dispatch("error", e);
            }.bind(this)
          );
        },
      },
      endPoint: "fluxos/",
      dataForm: {},
    };
  },
  components: {
    BaseCrud,
  },
  methods: {
    query: function (query) {
      let columns = {
        id: "id",
        nome: "nome",
        status: "status",
      };
      let filters = "";
      $.each(query, function (index, value) {
        filters += columns[index] + "=" + value + "&";
      });
      return filters;
    },
    abrirEditor(evento) {
      this.$router.push("/fluxos/editor/" + evento.row.id);
    },
  },
};
</script>
